// Consent initialization - loads WITHOUT defer
// This MUST load before GPT so TCF framework (__tcfapi) is available
// when GPT checks for consent
import '../sources/quantcast_choice_cmp.js';
import { preserveTcfLocator } from '../../modules/tcf_locator';

// Keep Turbo integration separate so vendor CMP snippets can be updated independently.
preserveTcfLocator(document);
